import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { FilterChipGroup } from './FilterChipGroup';
export const buildEmissorOrderProductFilterOptions = (products) => {
    const optionsByProductId = new Map();
    products.forEach(product => {
        if (!product.productId || optionsByProductId.has(product.productId)) {
            return;
        }
        optionsByProductId.set(product.productId, {
            id: product.productId,
            label: product.productName ?? product.productId,
            order: Number.isFinite(product.displayOrder) ? product.displayOrder : Number.MAX_SAFE_INTEGER,
        });
    });
    return [...optionsByProductId.values()].sort((first, second) => first.order - second.order || first.label.localeCompare(second.label));
};
export function EmissorOrderProductFilter({ options, value, onChange, testIdPrefix, }) {
    const { t } = useTranslation();
    return (_jsx(FilterChipGroup, { label: t('benefits.orders.filter.product'), options: options, selectedIds: value, onChange: onChange, testIdPrefix: testIdPrefix }));
}
